import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Home from "./components/Home/Home";
import Product from "./components/Product/Product";
import ProductSoftware from "./components/Product/ProductSoftware";
import Solution from "./components/Solution/Solution";
import About from "./components/About/About";
import VisionMission from "./components/About/VisionMission";
import OurPartners from "./components/About/OurPartners";
import OurCustomers from "./components/About/OurCustomers";
import Career from "./components/About/Career";
import ContactUs from "./components/About/ContactUs";
import UniqueProducts from "./components/Product/UniqueProducts";
import Support from "./components/Support/Support";
import Allproduct from "./components/Product/Allproduct";
import BackupandDisaster from "./components/Solution/BackupandDisaster";
import EnterpriseSearch from "./components/Solution/EnterpriseSearch";
import Hyperconverge from "./components/Solution/Hyperconverge";
import NetworkandWifi from "./components/Solution/NetworkandWifi";
import Loganalytic from "./components/Solution/Loganalytic";
import Virtualization from "./components/Solution/Virtualization";
import Virtualizationhpvvme from "./components/Solution/Virtualizationhpvvme";
import OpensourceERP from "./components/Solution/OpensourceERP";
import Security from "./components/Solution/Security";
import Firewall from "./components/Solution/Firewall";
import Privilege from "./components/Solution/Privilege";
import VAScan from "./components/Solution/VAScan";
import AutomatePentest from "./components/Solution/AutomatePentest";
import MicrosoftPowerPlatform from "./components/Solution/MicrosoftPowerPlatform";
import GitlabDevOps from "./components/Solution/GitlabDevOps";
import KatalonTestAutomation from "./components/Solution/KatalonTestAutomation";
import CaseStudy from "./components/About/CaseStudy";
import CustomerTicket from "./components/Support/CustomerTicket";
import CustomerTicket2 from "./components/Support/CustomerTickets";
import AdminTicket from "./components/Support/AdminTicket";
import SurveyPage from "./components/Support/SurveyPage";
import IT from "./components/IT Store/IT";
import { LanguageProvider } from "./components/LanguageContext";
import Maintenance from "./components/Support/Maintenance";
import Whoweare from "./components/About/Whoweare";
import Intusty from "./components/About/Intusty";
import PasswordReset from "./components/Support/PasswordReset";
import Pillarcard from "./components/pillarcard/pillarcard";
import TicketDetail from "./components/Support/TicketDetail";
import TicketDetailAdmin from "./components/Support/TicketDetailAdmin";
import NewTicketMenu from "./components/Support/NewTicketLayout";
import SettingMenu from "./components/Support/SettingLayout";
import Dashboard from "./components/Support/Dashboard";
import Infocustomer from "./components/Support/Infocustomer";
import Ticket2 from "./components/Support/Ticket2";
import Agent from "./components/Support/Agent";
import Department from "./components/Support/Department";
import CreateTickets from "./components/Support/CreateTickets";
import TicketAssessments from "./components/Support/TicketAssessments";
import AgentLogs from "./components/Support/AgentLogs";
import DashboardCus from "./components/Support/DashboardCus";
import VeeamIframePage from "./components/Product/VeeamIframePage";
import VeeamPage from "./components/Product/VeeamPage";

const App = () => {
  return (
    <LanguageProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<Navigate to="/home" />} />
            <Route path="/home" element={<Home />} />
            <Route path="/producthardware" element={<Product />} />
            <Route path="/productsoftware" element={<ProductSoftware />} />
            <Route path="/solutions" element={<Solution />} />
            <Route path="/aboutus" element={<About />} />
            <Route path="/visionmission" element={<VisionMission />} />
            <Route path="/partners" element={<OurPartners />} />
            <Route path="/customer" element={<OurCustomers />} />
            <Route path="/career" element={<Career />} />
            <Route path="/contactus" element={<ContactUs />} />
            <Route path="/productunique" element={<UniqueProducts />} />
            <Route path="/support" element={<Support />} />
            <Route path="/maintenance" element={<Maintenance />} />
            <Route path="/allproduct" element={<Allproduct />} />
            <Route path="/backupanddisaster" element={<BackupandDisaster />} />
            <Route path="/enterprisesearch" element={<EnterpriseSearch />} />
            <Route path="/hyperconverge" element={<Hyperconverge />} />
            <Route path="/networkandwifi" element={<NetworkandWifi />} />
            <Route path="/loganalytic" element={<Loganalytic />} />
            <Route path="/virtualization" element={<Virtualization />} />
            <Route
              path="/hpe-morpheus-vm-essentials-software"
              element={<Virtualizationhpvvme />}
            />
            <Route path="/opensourceerp" element={<OpensourceERP />} />
            <Route path="/security" element={<Security />} />
            <Route path="/product/:type" element={<VeeamPage />} />

            <Route path="/firewall" element={<Firewall />} />
            <Route
              path="/productsoftware/:type"
              element={<VeeamIframePage />}
            />
            <Route path="/privilegeaccessmanagement" element={<Privilege />} />
            <Route path="/vascreen" element={<VAScan />} />
            <Route path="/automatepentest" element={<AutomatePentest />} />
            <Route path="/whoweare" element={<Whoweare />} />
            <Route
              path="/microsoftpowerplatform"
              element={<MicrosoftPowerPlatform />}
            />
            <Route path="/gitlabdevops" element={<GitlabDevOps />} />
            <Route
              path="/katalontestautomation"
              element={<KatalonTestAutomation />}
            />
            <Route path="/casestudy" element={<CaseStudy />} />
            <Route path="/tickets" element={<CustomerTicket />} />
            <Route path="/survey/:TicketNumber" element={<SurveyPage />} />
            <Route path="/it" element={<IT />} />
            <Route path="/intusty" element={<Intusty />} />
            <Route path="/resetpass" element={<PasswordReset />} />
            <Route path="/pillarcard" element={<Pillarcard />} />
            <Route path="/ticket/:id" element={<TicketDetail />} />
            <Route path="/tickets/new" element={<NewTicketMenu />} />
            <Route path="/setting" element={<SettingMenu />} />
            <Route path="/admin" element={<AdminTicket />}>
              <Route path="customer-activity-logs" element={<Dashboard />} />
              <Route path="users" element={<Infocustomer />} />
              <Route path="tickets" element={<Ticket2 />} />
              <Route
                path="customer-tickets/:id"
                element={<CustomerTicket2 />}
              />
              <Route path="agent" element={<Agent />} />
              <Route path="department" element={<Department />} />
              <Route path="new" element={<CreateTickets />} />
              <Route
                path="ticket-assessments"
                element={<TicketAssessments />}
              />
              <Route path="agent-logs" element={<AgentLogs />} />
              <Route path="dashboard" element={<DashboardCus />} />
              <Route path="ticketadmin/:id" element={<TicketDetailAdmin />} />
            </Route>
          </Routes>
        </div>
      </Router>
    </LanguageProvider>
  );
};

export default App;
